import { migrations } from '../../../../../backend/features/accounts/entities/AccountRegistration/migrations';
import { accountRegistrationColumns, accountRegistrationMessageType, } from '../../../../../backend/features/accounts/shared';
export const accountRegistrationEntity = {
    version: 2,
    columns: accountRegistrationColumns,
    migrations: migrations,
    onTransformColumns: (context, params) => {
        return {
            // Prevent account registration with the same email while processing is in progress.
            // On success email duplication validation will be handled by account entity and on error system will allow registration again.
            email: params.data.status === 'processing' ? params.data.accountData.email : undefined,
        };
    },
    onChangeSync: (context, params) => {
        if (params.action === 'create' && params.data.status === 'processing') {
            context.queues.enqueue(accountRegistrationMessageType, { id: params.id }, '1');
        }
    },
    audit: {
        columnForAuditIdReplacement: 'email',
    },
};
